// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"b89907d3","lsc":"b0818bc9","others":"e78af1d6"}[chunkId] + ".chunk.js";
};